import { useCallback, useEffect, useState } from "react";
import { ParcConfigDto } from "api/real-estate";
import { realEstateAPI } from "services/swagger-api/realEstateAPI";

/**
 * Détecte le contexte parc sur la page tarificateur et charge sa config de couverture.
 * isParc = la config a des biens inclus (un risque mono-bien renvoie une config vide).
 */
export const usePricingParc = (riskId: string | undefined) => {
  const [config, setConfig] = useState<ParcConfigDto>();
  const [isLoading, setIsLoading] = useState(true);
  const [reloadKey, setReloadKey] = useState(0);

  const refetch = useCallback(() => setReloadKey((k) => k + 1), []);

  useEffect(() => {
    if (!riskId) {
      setIsLoading(false);
      return;
    }

    let cancelled = false;
    const load = async () => {
      setIsLoading(true);
      try {
        const cfg = await realEstateAPI.getParcConfig({ riskId });
        if (!cancelled) setConfig(cfg);
      } catch (error) {
        // Risque non immobilier / sans config → on reste en mode mono.
        if (!cancelled) setConfig(undefined);
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [riskId, reloadKey]);

  const isParc = (config?.biensInclus?.length ?? 0) > 0;
  return { isParc, config, isLoading, refetch };
};
